export default __webpack_public_path__ + "static/media/man-user.a194e240.svg";